import './validator.plugin.js';
import scrollto from '@utils/scrollto.js';
const addFormValidation = (form) => {
    if (!form)
        return;
    const validator = new Validator(form);
    form.validator = validator;
    function scrollToFirstError(el) {
        const firstInvalidField = el.querySelector('.is-invalid');
        const isMobile = true;
        if (firstInvalidField && isMobile) {
            scrollto(firstInvalidField, { duration: 700, offset: 100 });
        }
    }
    form.addEventListener('submit', (event) => {
        validator.reinit();
        const valid = validator === null || validator === void 0 ? void 0 : validator.validate(undefined, false);
        if (valid) {
            form.classList.remove('invalid');
            form.classList.add('valid');
        }
        else {
            event.preventDefault();
            form.classList.remove('valid');
            form.classList.add('invalid');
            scrollToFirstError(form);
        }
    });
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((control) => {
        control.addEventListener('change', () => validator.reset());
    });
};
document.querySelectorAll('form[data-validate]').forEach((form) => {
    addFormValidation(form);
});
